import { useQueryClient } from "@tanstack/react-query";

import { usePatchTestingControlsTestingControlId } from "../../../../../api/generated/testing-controls/testing-controls";
import { TESTING_CONTROLS_QUERY_KEY } from "../../list/queries/useTestingProgramTestingControlsQuery";

import { getTestingControlQueryKey } from "./useTestingControlQuery";

export function useUpdateTestingControlMutation() {
    const queryClient = useQueryClient();
    return usePatchTestingControlsTestingControlId({
        mutation: {
            onSuccess: (_data, vars) => {
                queryClient.invalidateQueries({
                    queryKey: getTestingControlQueryKey(vars.testingControlId),
                });
                queryClient.invalidateQueries({
                    queryKey: [TESTING_CONTROLS_QUERY_KEY],
                });
            },
        },
    });
}
